// 树形结构处理
export function toTree(data) {
	// 删除所有children,以防止多次调用
	data.forEach(item => {
		delete item.children
	})
	// 将数据存储为 以 id 为 KEY 的 map 索引数据列
	let map = {}
	data.forEach(item => {
		map[item.id] = item
	})
	let arr = []
	data.forEach(item => {
		// 以当前遍历项的pid,去map对象中找到索引的id
		let parent = map[item.parentId]
		// 如果找到索引，name说明此项不再顶级当中，那么需要把此项添加到，它对应的父级中
		if(parent){
			(parent.children || ( parent.children = [] )).push(item)
		} else{
			//如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 arr结果集中，作为顶级
			arr.push(item)
		}
	})
	return arr
}



// WEBPACK FOOTER //
// ./src/util/vTree.js